import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

// No lookbehind (Safari-safe). Matches [[chain:id]], [[chain:id|label]],
// [[symbol:SYM]], [[symbol:SYM|label]].
const TOKEN_RE = /\[\[(chain|symbol):([^|\]]+)(?:\|([^\]]+))?\]\]/g;

export function JournalBody({ body }: { body: string }) {
  const parts: ReactNode[] = [];
  let last = 0;
  let m: RegExpExecArray | null;
  TOKEN_RE.lastIndex = 0;
  while ((m = TOKEN_RE.exec(body)) !== null) {
    if (m.index > last) parts.push(body.slice(last, m.index));
    const [, kind, id, label] = m;
    const to = kind === 'chain' ? `/chains/${id}` : `/symbols/${id.toUpperCase()}`;
    parts.push(
      <Link key={`${m.index}`} to={to} className="text-brand-700 hover:underline">
        {label ?? id}
      </Link>
    );
    last = m.index + m[0].length;
  }
  if (last < body.length) parts.push(body.slice(last));
  return <span>{parts}</span>;
}
